export const formatPriceNumberPoint = (value: string | number | undefined): string => {
  if (!value) return '0';

  const [integerPart = '', decimalPart] = `${value}`.split('.');
  const sanitizedInteger = integerPart.replace(/[^\d]/g, '');
  const formattedInteger = sanitizedInteger.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if (decimalPart === undefined) {
    return formattedInteger;
  }

  const sanitizedDecimal = decimalPart.replace(/[^\d]/g, '').slice(0, 2);
  return sanitizedDecimal ? `${formattedInteger}.${sanitizedDecimal}` : formattedInteger;
};

export const formatPriceNumber = (value: string | number | undefined): string => {
  if (!value) return '0';
  if (`${value}`[0] === '-') return '0';

  const [integerPart = '', decimalPart] = `${value}`.split('.');
  const sanitizedInteger = integerPart.replace(/[^\d]/g, '');
  const formattedInteger = sanitizedInteger.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if (decimalPart === undefined) {
    return formattedInteger;
  }

  return formattedInteger;
};

export const formatNumber = (value: string | number | undefined): string => {
  if (!value) return '0';
  if (`${value}`[0] === '-') {
    return `-${formatNumber(-value)}${String(value).endsWith('%') ? '%' : ''}`;
  }

  const [integerPart = '', decimalPart] = `${value}`.split('.');
  const sanitizedInteger = integerPart.replace(/[^\d]/g, '');
  const formattedInteger = sanitizedInteger.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if (decimalPart === undefined) {
    return formattedInteger;
  }

  return formattedInteger;
};

export const priceToNumber = (value: string): number => {
  if (!value) return 0;
  return Number(value.replace(/,/g, ''));
};

export const priceToPointNumberValue = (value: string): number => {
  if (!value) return 0;
  return Number(value.replace(/,/g, ''));
};
